import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Controller, useFormContext } from 'react-hook-form';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { parseISO } from 'date-fns';
import { toLocalDayStart, toLocalDayEnd } from 'src/utils/date-filter-range';

const RHFDatepicker = ({
  name,
  label,
  options,
  spacing,
  helperText,
  children,
  emitLocalDayBoundary,
  ...other
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const handleChange = (date) => {
          if (emitLocalDayBoundary === 'start') {
            field.onChange(toLocalDayStart(date));
          } else if (emitLocalDayBoundary === 'end') {
            field.onChange(toLocalDayEnd(date));
          } else {
            field.onChange(date);
          }
        };

        const value =
          emitLocalDayBoundary && typeof field.value === 'string'
            ? parseISO(field.value)
            : field.value;

        return (
          <FormControl error={!!error} fullWidth={other?.fullWidth}>
            {label && <FormLabel>{label}</FormLabel>}
            <DatePicker
              {...field}
              value={value}
              onChange={handleChange}
              slotProps={{
                textField: {
                  fullWidth: true,
                },
              }}
              sx={{
                maxWidth: { md: 200 },
                ...(other?.controlStyle || {}),
              }}
            />
            {error && <FormHelperText sx={{ ml: 1 }}>{error?.message ?? helperText}</FormHelperText>}
          </FormControl>
        );
      }}
      {...other}
    >
      {children}
    </Controller>
  );
};

export default RHFDatepicker;
